<template>
  <div>
    <Table
      resource="Banner"
      :actions="actions"
      :items="$store.getters['banner/tableData']"
      :detail="$store.getters['banner/detailData']"
      :fields="$store.getters['banner/tableFields']"
      :pagination="$store.state.banner.tablePagination"
      :keyword="$store.state.banner.tableKeyword"
      :loading="$store.state.banner.loadingTable"
      :filter="$store.state.banner.tableFilter"
      :sort="$store.state.banner.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('banner/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('banner/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('banner/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('banner/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('banner/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('banner/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('banner/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('banner/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('banner/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('banner/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
